import { TFunction } from 'i18next'
import Admins from './Admins'

// Labels are translated at render time: module-level i18n.t() runs before
// i18n.init() (this module is imported ahead of locales/i18n) and returns undefined.
export const getAdminTypesOptions = (t: TFunction) => [
  { label: t('common.admin'), value: 'ADMINISTRATOR' },
  //   { label: 'SuperAdmin', value: 'SUPERADMIN' },
]

export default Admins
